var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Typography } from '../Typography/Typography';
export var CardDescription = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 24px;\n"], ["\n  color: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 24px;\n"])), function (props) { return props.theme.colors.text.alt; });
export default CardDescription;
var templateObject_1;
